import { render } from "./CaseUsers.vue?vue&type=template&id=0c0c206f&scoped=true&ts=true"
import script from "./CaseUsers.vue?vue&type=script&lang=ts"
export * from "./CaseUsers.vue?vue&type=script&lang=ts"

import "./CaseUsers.vue?vue&type=style&index=0&id=0c0c206f&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0c206f"]])

export default __exports__